import { Injectable, inject } from '@angular/core';
import { OrganizationFormGroup } from './organization-form-group.interface';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { phoneNumberValidator } from '../../validators/phone-number-validator';

@Injectable()
export class OrganizationFormModel {
  readonly fieldNames = {
    title: 'title',
    phoneNumber: 'phoneNumber',
    email: 'email',
    responsibleUserId: 'responsibleUserId',
  };

  form: FormGroup<OrganizationFormGroup>;

  constructor() {
    const formBuilder = inject(FormBuilder);

    this.form = formBuilder.group<OrganizationFormGroup>({
      title: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(128)],
      }),
      phoneNumber: new FormControl(null, [phoneNumberValidator]),
      email: new FormControl(null, [Validators.email]),
      responsibleUserId: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required],
      }),
    });
  }
}
